const flightSearchInput = (tripId, isTripSearch) => (store) => {
  if (isTripSearch) {
    return {
      searchInputs: {
        ...store.tripSearch.searchInputs.flight,
        staterooms: store.tripSearch.searchInputs.staterooms,
      },
      searchObj: {
        ...store.tripSearch.searchObj.flight,
        staterooms: store.tripSearch.searchObj.staterooms,
      },
      airlinesAutocompleteResults: store.tripSearch.searchInputs.flight.airlinesAutocompleteResults,
      defaultSearchObj: store.tripSearch.searchInputs.flight.defaultSearchObj
        || store.tripSearch.searchInputs.flight,
      requestId: store.tripSearch.searchObj.flight.requestId,
      searchProgress: store.tripSearch.searchObj.flight.searchProgress,
      hasUserInteractedWithFlightList: store.tripSearch.searchObj.flight
        && store.tripSearch.searchObj.flight.hasUserInteractedWithFlightList,
      foundTotalFlights: store.tripSearch.searchObj.flight
        && store.tripSearch.searchObj.flight.foundTotalFlights,
      totalFlights: store.tripSearch.searchResult
        && store.tripSearch.searchResult.total,
      breadCrumbsIndex: store.tripSearch.searchObj.flight.breadCrumbsIndex,
      selectedFlightSegments: store.tripSearch.searchObj.flight.selectedFlightSegments,
    };
  }
  const {
    searchObj,
    defaultSearchObj,
    airlinesAutocompleteResults,
    hasUserInteractedWithFlightList,
    searchProgress,
    requestId,
    queryString,
    foundTotalFlights,
    searchObjRecentSearch,
  } = store.flight.flightSearches[tripId] || {};
  return {
    searchObj: !searchObj ? {} : searchObj,
    searchInputs: !searchObj ? {} : searchObj,
    defaultSearchObj: !defaultSearchObj ? {} : defaultSearchObj,
    airlinesAutocompleteResults,
    requestId,
    searchProgress,
    hasUserInteractedWithFlightList,
    foundTotalFlights,
    totalFlights: store.flight.responses && store.flight.responses[queryString]
      && store.flight.responses[queryString].totalFlights,
    searchObjRecentSearch,
    breadCrumbsIndex: searchObj && searchObj.breadCrumbsIndex,
    selectedFlightSegments: searchObj && searchObj.selectedFlightSegments,
  };
};
export default flightSearchInput;
